export const LogoMark = ({ size = 40, className = "", src = "/logo-courthouse.png" }) => (
  <img
    src={src}
    alt="No Lawyer Lawsuit logo"
    style={{ width: size, height: "auto" }}
    className={className}
  />
);

export const Logo = ({ dark = false, src, markSize = 44, textSize = "text-[22px]" }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark
      size={markSize}
      src={src}
      className={dark ? "bg-white rounded-xl shadow-sm p-1" : "translate-y-[2px]"}
    />
    <span
      className={`font-display font-semibold ${textSize} tracking-tight leading-none whitespace-nowrap ${
        dark ? "text-[#FFFFFF]" : "text-[#111827]"
      }`}
    >
      No Lawyer Lawsuit
    </span>
  </span>
);
